import { Pipe, PipeTransform } from '@angular/core';
import { HWResourceService } from '../services/huawei-resource.service';


@Pipe({
    name: 'mediaUrlPipe',
    standalone: false
})
export class MediaUrlPipe implements PipeTransform {
  transform(url = '') {
    return HWResourceService.resolveMediaUrl(url);
  }
}
